import React from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { TextField, InputAdornment } from '@mui/material';

import SmartphoneIcon from '@mui/icons-material/Smartphone';

const PhoneInput = ({input: { ...inputProps }, meta: { touched, error } = {}, className, disabled, label, isLoading, required, style}) => {
  const formatPhone = (value) =>{
    return value.replace(/[^0-9]/g,"");
  }

  return(
    <div className="pc-field" style={style}>
      {label && (
        <label className="pc-field__label">
          {label}
          {required ? <i>*</i> : null}
        </label>
      )}
      <TextField
        error={!!(touched && error)}
        helperText={touched && error}
        onChange={({ target: { value } }) => inputProps.onChange(formatPhone(value))}
        value={inputProps.value || ''}
        InputProps={{
          startAdornment: 
                  <InputAdornment position="start">
                    <SmartphoneIcon size="small"/>
                  </InputAdornment>,
          inputProps:{
            ...inputProps,
          }
        }}
        className={className} 
        disabled={isLoading || disabled}
        hiddenLabel
        fullWidth
        size="small"
        variant="outlined"
      />
    </div>
  )
}
const mapStateToProps = (state, props) =>{
  const { fetch } = state;
  return {
      isLoading: !!fetch.loading
  }
}

export default compose(
  connect(mapStateToProps),
)(PhoneInput);
